import { BoxProps } from '@dotfile/frontend/shared/design-system';

export const CONTENT_MAX_WIDTH: BoxProps['maxWidth'] = '800px';
